// Apolo IDE — useMergeQueue (sprint hgmq-finish, P4-T02).
//
// Polls the Honest-Green Merge Queue read-model for the active session into
// the store (code.mergeQueue), so the Glass Box lane in TasksPanel renders
// live queue state. Pull+poll (like useSessionStatusPoll), not push. The lane
// is VERDICT-ONLY — nothing here lands a PR.

import { useEffect } from 'react';
import { useAgentStore } from '../store/useAgentStore.js';

const INTERVAL_MS = 10000;

export function useMergeQueue(sessionId) {
  const active = useAgentStore((s) => s.activeWorkspace === 'code');
  const refresh = useAgentStore((s) => s.refreshMergeQueue);

  useEffect(() => {
    if (!active || !sessionId) return undefined;
    let cancelled = false;
    const tick = () => { if (!cancelled) refresh(sessionId); };
    tick();
    const id = setInterval(tick, INTERVAL_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, [active, sessionId, refresh]);
}
